module.exports = __webpack_public_path__ + "static/media/playngoo.ba5aa05a.jpeg";